import React from 'react'
import styled from '@emotion/styled'
import { mediaQueries } from '../../../theme'
import BaseTemplateLink from './template-link'

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: ${p => p.theme.space[8]};

  ${mediaQueries.md} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

const TemplateLink = styled(BaseTemplateLink)`
  ${mediaQueries.lg} {
    border-width: 2px;
  }
`

const TemplateList = ({
  templates,
  defaultTheme,
  linkedTemplates,
  templateLoadingStrategy,
  className,
}) => (
  <Grid className={className}>
    {templates.map((tpl, index) => (
      <TemplateLink
        key={index}
        target={tpl}
        templates={linkedTemplates || templates}
        defaultTheme={defaultTheme}
        loading={templateLoadingStrategy?.(index, tpl.wid)}
      />
    ))}
  </Grid>
)

export default TemplateList
